<template>
  <section
    class="component-daef29d2"
    resmed-component-name="promo_fullwidth_card_graphic_text_cta"
    v-bind:style="styles"
    v-bind:class="{ 'has-illustration-icon': acf['illustration-icon'] }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col-md-11 text-center">
            <div class="card">
              <eyebrow-icon
                v-if="acf.eyebrowicon.icon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                v-bind:align="'center'"
              ></eyebrow-icon>
              <figure v-else class="illustration-icon">
                <img
                  class="img-fluid"
                  v-bind:src="acf['illustration-icon']"
                  alt=""
                />
              </figure>

              <div v-if="acf.title" class="title">
                <h5>{{ acf.title }}</h5>
              </div>
              <h2 v-html="acf.headline"></h2>
              <div v-if="acf.description" v-html="acf.description"></div>

              <div class="text-center mt-4 resources">
                <a
                  v-if="acf.cta.href"
                  v-bind:href="acf.cta.href"
                  v-bind:target="acf.cta.target"
                  class="btn cta-pill filled-red icon right-arrow"
                  >{{ acf.cta.text }}</a
                >
                <a
                  v-if="acf['apple-app-store']"
                  target="_blank"
                  v-bind:href="acf['apple-app-store']"
                  class="btn apple-store d-block text-hide"
                  >Download on the App Store</a
                >
                <a
                  v-if="acf['google-play']"
                  target="_blank"
                  v-bind:href="acf['google-play']"
                  class="btn google-play d-block text-hide"
                  >Get it on Google Play</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-daef29d2", // promo_fullwidth_card_graphic_text_cta
  props: ["acf"],
  data() {
    return {
      styles: {
        "background-color": this.acf.layout["background-color"],
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        this.styles = Object.assign({}, this.styles, {
          "background-position": "center center",
          "background-image": `url(${this.acf.layout["background-image"]})`,
        });

        if (["xs", "sm"].includes(val)) {
          this.$set(this.styles, "background-position", "center top");

          if (this.acf.layout["background-image-xs"]) {
            this.$set(
              this.styles,
              "background-image",
              `url(${this.acf.layout["background-image-xs"]})`
            );
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-daef29d2 {
  padding: 5rem 0;

  background-image: url(#{$assets}/images/background-gray-dots.svg);
  background-size: cover;

  @media (min-width: 768px) {
    background-position: center center;
  }

  &.has-illustration-icon {
    padding: 8rem 0 5rem 0;
  }
}

.component {
  h2 {
    margin-bottom: 1rem;
    position: relative;
    @extend %eyebrow-center;
  }

  .title + h2 {
    &:before {
      display: none;
    }
  }

  h5 {
    position: relative;
    @extend %eyebrow-center;
  }

  figure {
    &.illustration-icon {
      width: 160px;
      position: absolute;
      top: -4.25rem;
      left: 50%;
      transform: translateX(-50%);

      img {
        margin: 0 auto;
      }
    }
  }

  .card {
    position: relative;
    padding: 5rem 3rem 2rem 3rem;
    background-image: linear-gradient(to bottom, $cc-resmed-white, #efefef);
    border-radius: 6px;
    box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.15);
  }

  .resources {
    display: flex;
    flex-direction: column;
    align-items: center;

    .btn {
      margin: 0 0 1rem 0;

      &:last-child {
        margin-bottom: 0;
      }
    }

    @media (min-width: 768px) {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      .btn {
        margin: 0 1rem 0 0;

        &:last-child {
          margin: 0;
        }
      }
    }
  }
}
</style>